import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { PixPaymentFavored } from '../../models/payment-favored.model';
import { PixKeyType } from '../../models/key-type.enum';
import { ModalConfirmComponent } from '../../../../shared/modal-confirm/modal-confirm.component';
import { PixPaymentKeyService } from '../payment-key.service';
import { Util } from '../../../../utils/util';
import { PixKeysService } from '../../keys/keys.service';
import { EventTypes } from '../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { PixKey } from '../../models/key.model';
import { PixPaymentFavoredView } from '../../models/payment-favored-view.model';
import * as moment from 'moment';
import { TipoIniciacaoTransferencia } from '../../models/tipo-iniciacao-transacao.enum';

@Component({
	selector: 'app-pix-payment-key-favored-list',
	templateUrl: './favored-list.component.html',
	styleUrls: ['./favored-list.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyFavoredListComponent implements OnInit {

	public dataSource: MatTableDataSource<PixPaymentFavoredView>;
	public displayedColumns: Array<string> = ['nome', 'tipoChave', 'codigo', 'other'];
	public list: PixPaymentFavoredView[] = [];

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private pixPaymentKeyService: PixPaymentKeyService,
		private pixKeysService: PixKeysService,
	) {}

	ngOnInit(): void {
		this.getList();
	}

	getList() {
		this.list = [];

		this.pixKeysService.getFavoreds().subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				this.list = this.convertModelToView(Util.keysToCamel(result.Retorno) as PixPaymentFavored[]);
				this.dataSource = new MatTableDataSource(this.list);
			} else {
				this.router.navigate(['pix/pagamento/favorecido/adicionar']);
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	convertModelToView(items: PixPaymentFavored[]): PixPaymentFavoredView[] {
		return items.map(item => new PixPaymentFavoredView(item));
	}

	applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	delete(item: PixPaymentFavoredView) {
		const dialogRef = this.dialog.open(ModalConfirmComponent, {
			width: '420px',
			data: {
				title: 'Excluir favorecido',
				topText: item.nome + ' ' + this.getTopText(item),
				text: 'Se prosseguir com a exclusão, será necessário realizar novamente a pesquisa pela chave para enviar um PIX para este favorecido.',
				confirmButton: 'Sim, quero excluir',
				backButton: 'Não quero excluir',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.pixPaymentKeyService.setSelectedPixPaymentFavoredViewToDelete(item);
				this.router.navigate(['pix/pagamento/favorecido/excluir']);
			}
		});
	}

	getTopText(item: PixPaymentFavoredView): string {
		switch (item.tipoChave) {
			case PixKeyType.CPF:
				return '- CPF: ' + Util.formatCpfCnpj(item.codigo);
			case PixKeyType.CNPJ:
				return '- CNPJ: ' + Util.formatCpfCnpj(item.codigo);
			case PixKeyType.EMAIL:
				return '- E-mail: ' + item.codigo;
			case PixKeyType.PHONE:
				return '- Telefone celular: ' + Util.formatPhone(item.codigo);
			case PixKeyType.EVP:
				return '- Chave aleatória: ' + item.codigo;
			case PixKeyType.MANUAL:
				return '- Ag: ' + item.numeroAgencia + ' Conta: ' + item.numeroConta;
		}
	}

	select(item: PixPaymentFavoredView) {
		item.tipoIniciacaoTransacao = TipoIniciacaoTransferencia.FAVORECIDO_CADASTRADO;

		if (item.tipoChave === PixKeyType.MANUAL) {
			this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(item);
			this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);
			return;
		}

		this.pixKeysService.getAccountByCodeAndType(item.codigo, item.tipoChave).subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const model = new PixPaymentFavoredView(Util.keysToCamel(result.Retorno) as PixPaymentFavored);
				this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(model);
				this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);
			} else {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Erro ao consultar favorecido, tente mais tarde.' });
			}
		});
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-list/favored-list.component.ts